import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { BASE_URL, BASE_FILE_URL } from './../../Environment';
import { toast } from 'react-toastify';

function IDCard() {
    const [setting, setSetting] = useState([]);
    const [details, setDetails] = useState([]);
    const accessToken = localStorage.getItem('accessToken');
    useEffect(() => {
        document.title = 'Infomart | Agent ID Card';
        axios.get(`${BASE_URL}/setting`, {
            headers: {
                'Content-Type': 'application/json'
            }
        }).then((res) => {
            setSetting(res.data.data);
        }).catch((res) => {
            toast.error(res.response.data.msg, { autoClose: 3000 });
        });
        axios.get(`${BASE_URL}/agent/details`, {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${accessToken}`
            }
        }).then((res) => {
            setDetails(res.data.data);
        }).catch((res) => {
            toast.error(res.response.data.msg, { autoClose: 3000 });
        });
        setTimeout(() => {
            window.print();
        }, 2000);
    }, []);
    return (
       <table
  style={{
    border: '1px solid #000',
    backgroundColor: '#fde7b0',
    width: '600px',
    borderCollapse: 'separate',
    borderSpacing: '0',
  }}
  cellPadding="15"
>
  <tbody>
    {/* Header row: logo left, photo right */}
    <tr>
      <td colSpan="2" style={{ verticalAlign: 'top' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
          <img src={BASE_FILE_URL + setting.logo} height="90" width= "110" alt="Logo" />
          <div
            style={{
              width: '100px',
              height: '100px',
              border: '2px solid #000',
              textAlign: 'center',
              fontSize: '12px',
              backgroundColor: '#fff',
              lineHeight: '80px',
            }}
          >
            <img src={BASE_FILE_URL + details.image}  style={{
              width: '100px',
              height: '100px',}} alt="Logo" />
          </div>
        </div>
      </td>
    </tr>

    {/* Associates Title */}
    <tr>
      <td colSpan="2" style={{ fontWeight: 'bold', paddingTop: '10px' ,fontSize: '14px',}}>Associates</td>
    </tr>

    {/* Name and ID No */}
    <tr>
      <td style={{ paddingTop: '5px',fontSize: '14px' }}>
        <span style={{ fontWeight: 'bold' }}>Name: </span>{details.name}
      </td>
      <td style={{ paddingTop: '5px', textAlign: 'right',fontSize: '14px' }}>
        <span style={{ fontWeight: 'bold' }}>ID No: </span>{details.agent_id}
      </td>
    </tr>

    {/* Address */}
    <tr>
      <td colSpan="2" style={{ paddingTop: '5px',fontSize: '14px' }}>
        <span style={{ fontWeight: 'bold' }}>Full Address: </span>
        {details.city}, {details.state}, {details.pincode}, {details.country}
      </td>
    </tr>

    {/* Horizontal Line */}
    <tr>
      <td colSpan="2" style={{ paddingLeft: '10px' }}>
        <hr style={{ margin: '5px 0' }} />
      </td>
    </tr>

    {/* Footer Info */}
   <tr>
      <td colSpan="2" style={{ fontSize: '12px' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <div>
            <div style={{ fontWeight: 'bold' }}>Infomart International</div>
            <div>
              56/79, N. S. C. Bose Road, (10, Regent Colony), Ground Floor, P.O. - Regent Park,<br />
              Kolkata, West Bengal, India, Pin - 700040
            </div>
          </div>
          <div style={{ whiteSpace: 'nowrap',fontWeight: 'bold' , paddingLeft: '10px' }}>
            Mob No : 8240971068
          </div>
        </div>
      </td>
    </tr>
  </tbody>
</table>


    );
}

export default IDCard;
